<template>
  <div class="companyMember">
    <commonHeader :title="'公司成员'"></commonHeader>
    <userCenterTable
      :isShowLoading="isShowLoading"
      :tableData="tableData"
      :totalCount="totalCount"
      :pageSize="params.pageSize"
      :pageNumber="params.pageNumber"
      :field-data="fieldData"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
    </userCenterTable>
  </div>
</template>

<script>
import { baseContent } from '../mixin/baseContent'
export default {
  name: 'CompanyMember',
  mixins: [baseContent],
  data() {
    return {
      dataUrl: '/front/userCenter/colleague',
      fieldData: [
        {
          field: 'userName',
          label: '姓名',
          width: '200',
          type: 'text'
        },
        {
          field: 'userPhone',
          label: '手机号',
          width: '170',
          type: 'text'
        },
        {
          field: 'status',
          label: '状态',
          width: '200',
          type: 'status',
          statusOption: {
            'aaaaaaaaaaaaaaaaaaaaaaaaaaaaa006': {
              className: 'greenTag',
              label: '已关联'
            },
            'aaaaaaaaaaaaaaaaaaaaaaaaaaaaa007': {
              className: 'grayTag',
              label: '未关联'
            }
          }
        },
        {
          field: 'inputTime',
          label: '注册时间',
          width: '200',
          type: 'text'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
.companyMember {
  position: relative;
  height: 755px;
}

</style>
